import api from '../services/api';

/** Shown when the user declines confirming that aging is complete before bottling. */
export const AGING_MUST_COMPLETE_FOR_BOTTLING =
  'The aging process must be completed in order to create a bottling run for it';

export const AGING_COMPLETED_CONFIRM_QUESTION = 'Has the aging process been completed?';

export const AGING_COMPLETED_CONFIRM_TITLE = 'Complete aging before bottling';

function toDateOnly(dateString?: string | null): string | undefined {
  if (!dateString) return undefined;
  return dateString.includes('T') ? dateString.split('T')[0] : dateString;
}

/**
 * Marks an aging process Completed so bottling can proceed.
 * Uses an existing end date when present; otherwise today (YYYY-MM-DD).
 */
export async function completeAgingForBottling(aging: {
  id: number;
  end_date?: string;
  endDate?: string;
}): Promise<unknown> {
  const end_date =
    toDateOnly(aging.end_date) ||
    toDateOnly(aging.endDate) ||
    new Date().toISOString().split('T')[0];

  const response = await api.put(`/api/aging/${aging.id}`, {
    status: 'Completed',
    end_date,
  });
  return response.data;
}
